angular.module( 'acme.view.resolveFailed', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.resolveFailed.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resolveFailed = {
        name: 'resolveFailed',
        url: '/resolveFailed',
        views: {
          "main": {
            controller: 'ResolveFailedController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/resolveFailed/resolveFailed.tpl.html'
          }
        },
        data: {
          pageTitle: 'An error has occurred'
        }
      };

    $stateProvider
      .state(resolveFailed);
});
